import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Component, Inject } from '@angular/core';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { MedicalServiceService } from '../../../services/medical-service.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-medical-appointment-reappointment-dialog',
  templateUrl: 'medical-appointment-reappointment-dialog.component.html',
  styleUrls: ['./medical-appointment-reappointment-dialog.component.css']
})
export class MedicalAppointmentReappointmentDialogComponent {

  loading = false;
  form: FormGroup;
  constructor(
    public dialogRef: MatDialogRef<MedicalAppointmentReappointmentDialogComponent>
    , private formBuilder: FormBuilder
    , private notificationToastService: NotificationToastService
    , private medicalServiceService: MedicalServiceService
    , @Inject(MAT_DIALOG_DATA) public medicalAppointmentId: number) {
      this.form = this.formBuilder.group({
        ReappointmentDuration: ['', Validators.required],
      });
  }

  async reAppointment() {
    try {
      if (!this.form.invalid) {
        this.loading = true;
         await this.medicalServiceService.medicalAppointmentCheckReappointment(
           this.medicalAppointmentId, this.form.controls.ReappointmentDuration.value);
           this.dialogRef.close(true);
        }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Recitación del turno');
    } finally {
      this.loading = false;
    }
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

}
